import DateObj from './Date'
import DateEditor from './DateEditor'
import Zenkaku from '../../../zzl-lib/Zenkaku'
import Draggable from 'vuedraggable'

export default {
	name: 'DateListEditor',
	props: {
		value: {
			type: Object,
		},
		dateAutofill: {
			type: [Boolean, Number],
			default: false
		},
		timeAutofill: {
			type: Boolean,
			default: false
		},
		dateRange: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {}
	},
	components: {
		DateEditor,
		Draggable,
	},
	template: `
		<Draggable class="date-list-editor"
			v-model="value.items"
			draggable=".date-list-editor-date-wrap"
			handle=".date-list-editor-move-handle"
			chosen-class="date-list-editor-chosen"
			ghost-class="date-list-editor-ghost"
		>
			<div v-for="(item, index) in value.items" :key="item.id"
				class="date-list-editor-date-wrap"
			>
				<div class="date-list-editor-date-cnt">
					<span class="date-list-editor-index">({{ index + 1 }})</span>
					<DateEditor v-model="value.items[index]"
						@dateInput="onDateInput(index)"
						@dateToInput="onDateToInput(index)"
						@timeFromInput="onTimeFromInput(index)"
						@timeToInput="onTimeToInput(index)"
						:dateRange="dateRange"
					/>
				</div>
				<div class="date-list-editor-move-handle" title="ドラッグで移動">
					<span class="glyphicon glyphicon-move" aria-label="ドラッグで移動"></span>
				</div>
				<div class="date-list-editor-remove-btn" title="削除"
					@click="removeItem(index)"
				>
					<span class="glyphicon glyphicon-remove" aria-label="削除"></span>
				</div>
			</div>
			<div class="date-list-editor-add-btn"
				@click="addItem"
			>
				<span class="glyphicon glyphicon-plus"></span>
				日付を追加
			</div>
		</Draggable>
	`,
	mounted() {
	},
	methods: {
		addItem () {
			this.value.items.push(DateObj.create())
		},
		removeItem (index) {
			this.value.items.splice(index, 1)
		},
		onDateInput (index) {
			if (this.dateAutofill === false) return
			const { items } = this.value
			let val = items[index].date
			if (!val) return
			for (let i = index + 1; i < items.length; i++) {
				if (items[i].date) break
				val = new Date(val.getFullYear(), val.getMonth(), val.getDate() + this.dateAutofill)
				items[i].date = val
			}
		},
		onDateToInput (index) {
			if (this.dateAutofill === false || !this.dateRange) return
			const { items } = this.value
			let val = items[index].date_to
			if (!val) return
			for (let i = index + 1; i < items.length; i++) {
				if (items[i].date_to) break
				val = new Date(val.getFullYear(), val.getMonth(), val.getDate() + this.dateAutofill)
				items[i].date_to = val
			}
		},
		onTimeFromInput (index) {
			if (this.timeAutofill === false) return
			const { items } = this.value
			const val = items[index].time_from
			if (!val) return
			for (let i = index + 1; i < items.length; i++) {
				if (items[i].time_from) break
				items[i].time_from = val
			}
		},
		onTimeToInput (index) {
			if (this.timeAutofill === false) return
			const { items } = this.value
			const val = items[index].time_to
			if (!val) return
			for (let i = index + 1; i < items.length; i++) {
				if (items[i].time_to) break
				items[i].time_to = val
			}
		}
	}
}
